import { Text } from "@/components/Text";

import { cn } from "@/lib/utils";

export const EarningsSectionLabel = ({
  children,
  className,
}: {
  children: string;
  className?: string;
}) => {
  /* Render */
  const render = () => (
    <Text
      className={cn(
        "text-xs font-semibold uppercase text-slate-500",
        className,
      )}
    >
      {children}
    </Text>
  );

  return render();
};
